const FormationMap = require('ffss/component/row/formation/Map');
const FormationList = require('ffss/component/row/formation/List');

class FormationSearch{
    defaultOptions() {
        return {
        	'$container': null,
        	'length': 1000,//number of loaded formation
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onClickNext = this.onClickNext.bind(this);

        this.$container = this.settings.$container;
        if(!this.$container){
        	window.notify("$container is missing in component/row/FormationSearch","error");
        }

        this.$btnDisplayMap = $('.btn-display-map',this.$container);
        this.$btnDisplayList = $('.btn-display-list',this.$container);
        this.$mapContainer = $('.formation-search-map',this.$container);
        this.$listContainer = $('.formation-search-list',this.$container);
        this.$noResultContainer = $('.formation-search-noresult',this.$container);

        this.$form = $('.formation-search-form',this.$container);
        this.$resultContainer = $('.formation-search-result-container',this.$container);
        this.$loader = $('.formation-search-loader',this.$container);
        this.$diplomeTitle = $('.formation-search-diplome-title',this.$container);
        this.$diplomeDescription = $('.formation-search-diplome-description',this.$container);

        this.$filterDiplome = $('select[name="diplome"]',this.$form);
        this.$filterRegion = $('select[name="region"]',this.$form);
        this.$filterDepartement = $('select[name="departement"]',this.$form);
        this.$filterOrganisme = $('select[name="organisme"]',this.$form);
        this.$filterPeriod = $('input[name="period"]',this.$form);

        this.displayMode = 'list';

        this.currentOffset = 0;
        this.currentRequest =  null;

        this.initialize();
    }


    isMapDisplayed(){
    	return this.displayMode == 'map' ? true : false;
    }

    initialize(){
    	var self = this;


    	this.$btnDisplayMap.on('click',function(event){
    		event.preventDefault();
    		event.stopPropagation();

    		self.showMap();
    	})

    	this.$btnDisplayList.on('click',function(event){
    		event.preventDefault();
    		event.stopPropagation();

    		self.showList();
    	})


    	this.$form.on('submit',this.onSubmit);
		this.$filterDiplome.on('change',this.onFilterChange);
		this.$filterRegion.on('change',this.onFilterChange);
		this.$filterDepartement.on('change',this.onFilterChange);
		this.$filterOrganisme.on('change',this.onFilterChange);
		this.$filterPeriod.on('change',this.onFilterChange);


		this.map = new FormationMap({
			'$container': this.$mapContainer,
		});
		
		this.list = new FormationList({
			'$container': this.$listContainer,
			//'onClickNext': this.onClickNext, //disabled load more btn, it has side effect on map view
			'mode': 'general'
		});

		if(this.$filterDiplome.val()){
			setTimeout(function(){
				self.$filterDiplome.trigger('change');
			}, 300)
		}

    	if(this.canSubmit()){
    		this.$form.trigger('submit');
    	}
    }

    showMap(){
    	this.displayMode = 'map';
		this.$btnDisplayMap.hide();
		this.$btnDisplayList.show();

		this.$mapContainer.show();
		this.$listContainer.hide();

		this.map.onShow();
    }

    showList(){
    	this.displayMode = 'list';
		this.$btnDisplayMap.show();
		this.$btnDisplayList.hide();

		this.$mapContainer.hide();
		this.$listContainer.show();

		this.list.onShow();
    }

    onFilterChange(event){
    	let $filter = $(event.target);

    	let filterName = $filter.attr('name');

    	this.currentOffset = 0;

    	switch(filterName){
    		case 'diplome':
    			this.onChangeDiplome();
			break;

    		case 'region':
    			this.onChangeRegion();
			break;

    		case 'departement':
    			this.onChangeDepartement();
			break;

    		case 'organisme':
    			this.onChangeOrganisme();
			break;
    	}

    	if(this.canSubmit()){
    		this.$form.trigger('submit');
    	}
    }

    canSubmit(){
    	let idDiplome = this.$filterDiplome.val();
    	let idRegion = this.$filterRegion.val();
    	let idOrganisme = this.$filterOrganisme.val();
    	let period = this.$filterPeriod.val();

    	if(!idDiplome){
    	//	return false;
    	}
    	if(!idOrganisme && !idRegion){
    	//	return false;
    	}
    	if(!period){
    	//	return false;
    	}

    	return true;
    }

    onChangeDiplome(){
    	let idDiplome = this.$filterDiplome.val();

		this.$diplomeTitle.html('');
		this.$diplomeDescription.html('');

		let $diplome = $('option[value="'+idDiplome+'"]',this.$filterDiplome);
		if($diplome.length > 0){
			this.$diplomeTitle.append($diplome.attr('title'));
			this.$diplomeDescription.append($($diplome.data('description')).text());
		}
    }

    onChangeRegion(){
    	let idRegion = this.$filterRegion.val();

    	if(idRegion){
	    	let idDepartement = this.$filterDepartement.val();
	    	if(idDepartement){
	    		let $departement = $('option[value="'+idDepartement+'"]',this.$filterDepartement);
	    		if($departement.data('region') != idRegion){
	    			this.$filterDepartement.val("").trigger('change');
	    		}
	    	}
    		$('option',this.$filterDepartement).data('hidden',true);
    		$('option[data-region="'+idRegion+'"]',this.$filterDepartement).data('hidden',false);
    		$('option[value=""]',this.$filterDepartement).data('hidden',false);
	    }else{
	    	$('option',this.$filterDepartement).data('hidden',false);
	    }

	    this.$filterDepartement.select2('destroy');
	    this.$filterDepartement.select2({
            templateResult: function(option) {
                let $option = $(option.element);
                if($option.data('hidden')){
                    return null;
                }
                return option.text;
            }
        });
    }

    onChangeDepartement(){
    	
    	let idDepartement = this.$filterDepartement.val();

    	if(idDepartement){

	    	let $departement = $('option[value="'+idDepartement+'"]',this.$filterDepartement);

	    	let region = $departement.data('region');

	    	this.$filterRegion.val(region).trigger('change.select2');
	    }
    }

    onChangeOrganisme(){
    	let idOrganisme = this.$filterOrganisme.val();
    	if(idOrganisme){
    		let $organisme = $('option[value="'+idOrganisme+'"]',this.$filterOrganisme);
    		let idRegion = $organisme.data('region');
	    	this.$filterRegion.val(region).trigger('change.select2');
    	}
    }

    onSubmit(event){
		event.preventDefault();
		event.stopPropagation();

		this.doSubmit(true);

    }

    getData(){
    	let data  = this.$form.serializeArray();

    	data.push({
    		'name': 'mode',
    		'value': 'public',
    	});

    	data.push({
    		'name': 'start',
    		'value': this.currentOffset
    	});

    	data.push({
    		'name': 'length',
    		'value': this.settings.length,
    	});

    	return data;
    }

    doSubmit(clearList){
    	var self = this;

        if(this.currentRequest != null){
            this.currentRequest.abort();
        }

		this.$resultContainer.show();
		this.$loader.show();
		this.$noResultContainer.hide();
		if(clearList){
			this.$listContainer.hide();
		}
		this.$mapContainer.hide();

		this.list.setNeedClear(clearList);

    	let data = this.getData();

        this.currentRequest = $.ajax({
    		'url': this.$form.attr('action'),
    		'method': this.$form.attr('method'),
    		'data': data
    	})
    	.done(function(xhr){
    		if(xhr.success){
    			self.showResult(xhr);
    		}else{
    			window.notify("todo notification of error : "+ xhr.message,"error");
    		}
    	})
    	.fail(function(){
    		window.notify("todo notification of error","error");
    	})
    	.always(function(){
    		self.$loader.hide();
    	});

    }

    showResult(xhr){
    	let data = xhr.data;
    	if(data.length == 0){
    		this.$noResultContainer.show();
    	}else{
    		this.fillMapWithResult(xhr);
    		this.fillListWithResult(xhr);
	    	if(this.isMapDisplayed()){
	    		this.$mapContainer.show();
	    	}else{
	    		this.$listContainer.show();
	    	}
	    }
    }

    fillMapWithResult(data){
		this.map.setData(data);
    }

	fillListWithResult(data){
		this.list.setData(data);
	}

	onClickNext(offset){
		this.currentOffset = offset;

		this.doSubmit(false);
	}


}

module.exports = FormationSearch;